<div class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon matTooltip="Retour vers l'administration" [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

  </div>

  <app-admin-counter-new-booking></app-admin-counter-new-booking>


</div>
